export default {
    props: {
        zoomableMousewheel: {
            type: Boolean,
            kComposite: 'zoomable.mousewheel'
        }, 
        zoomableMousewheelLock: {
            type: String,
            kComposite: 'zoomable.mousewheel.lock'
        }, 
        zoomableSelection: {
            type: Boolean,
            kComposite: 'zoomable.selection'
        }, 
        zoomableSelectionKey: {
            type: String,
            kComposite: 'zoomable.selection.key'
        }, 
        zoomableSelectionLock: {
            type: String,
            kComposite: 'zoomable.selection.lock'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Zoomable.js